import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';

export default function customTicketBtn() {
  const widgetName = 'customTicketBtn';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof customTicketBtnOpts === 'undefined' ? null : customTicketBtnOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }
  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      const ticketItem = data.items[0];

      if (hasData) {
        createCustomTicketBtn(ticketItem, widgetName);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomTicketBtn(widgetData, widgetName) {
    $(`#${widgetName}`).addClass('header-button');

    const $item = $widget.find('.card-widget-item');
    const { Title, URL } = widgetData;

    if (URL == null || URL === '') {
      missingWidget(widgetName);
      $widget.remove();

      return;
    }

    $item.replaceWith(
      `<a href="${URL}" class="button" ${updateLinksAttributes(URL, Title)}>
        <span class="btn-label">${Title}</span>
      </a>`,
    );
  }
}
